import { render, staticRenderFns } from "./BatchManagementButton.vue?vue&type=template&id=10f7bffa&scoped=true&"
import script from "./BatchManagementButton.vue?vue&type=script&lang=js&"
export * from "./BatchManagementButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f7bffa",
  null
  
)

export default component.exports